import Script from 'next/script';
import { type FC } from 'react';

import { REMOVE_AMP_DEVICE_ID_QUERY_PARAM_SCRIPT } from './scripts';

export const RemoveAmplitudeDeviceIdScript: FC = () => {
  return process.env.NEXT_PUBLIC_AMPLITUDE_API_KEY ? (
    <Script id="remove-amplitude-device-id-script" type="text/javascript">
      {REMOVE_AMP_DEVICE_ID_QUERY_PARAM_SCRIPT}
    </Script>
  ) : null;
};
